<nav class="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg">
    <div class="container-fluid">
        <div class="navbar-brand">
            <span class="navbar-logo">
                <img src="assets/images/vestra_logo.png" alt="" style="height: 4.2rem" />
            </span>
        </div>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-bs-toggle="collapse" data-target="#navbarSupportedContent" data-bs-target="#navbarSupportedContent" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <div class="hamburger">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>
        <div #navbar class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav nav-dropdown gap-4" data-app-modern-menu="true">
                <li class="nav-item" *ngIf="showMenu">
                    <a class="nav-link text-info display-7" [routerLink]="['/home']" routerLinkActive="active" (click)="closeMenu()">
                        <span class="fa fa-home mbr-iconfont mbr-iconfont-btn" style="color: #000"></span>
                        {{ 'menu.home_page' | translate | uppercase }}
                    </a>
                </li>
                <li class="nav-item" *ngIf="showMenu && canSeeProviders">
                    <a class="nav-link text-info display-7" [routerLink]="['/administration/strava-webhook-list']" routerLinkActive="active" (click)="closeMenu()">
                        <span class="fa fa-running mbr-iconfont mbr-iconfont-btn" style="color: #000"></span>
                        {{ 'menu.strava_webhook_list' | translate | uppercase }}
                    </a>
                </li>
                <li class="nav-item" *ngIf="showMenu && canSeeProviders">
                    <a class="nav-link text-info display-7" [routerLink]="['/administration/vestra-user-list']" routerLinkActive="active" (click)="closeMenu()">
                        <span class="fa fa-street-view mbr-iconfont mbr-iconfont-btn" style="color: #000"></span>
                        {{ 'menu.user_list' | translate | uppercase }}
                    </a>
                </li>
                <li class="nav-item" *ngIf="showMenu && canSeeSoftware">
                    <a class="nav-link text-info display-7" [routerLink]="['/administration/partner-list']" routerLinkActive="active" (click)="closeMenu()">
                        <span class="fa fa-handshake mbr-iconfont mbr-iconfont-btn" style="color: #000"></span>
                        {{ 'menu.partner_list' | translate | uppercase }}
                    </a>
                </li>
                <li class="nav-item" *ngIf="showMenu && canSeeSoftware">
                    <a class="nav-link text-info display-7" [routerLink]="['/administration/coupons']" routerLinkActive="active" (click)="closeMenu()">
                        <span class="fa fa-ticket-alt mbr-iconfont mbr-iconfont-btn" style="color: #000"></span>
                        {{ 'menu.coupons' | translate | uppercase }}
                    </a>
                </li>
                <li class="nav-item" *ngIf="showMenu">
                    <a class="nav-link text-info display-7" (click)="logout()">
                        <span class="fa fa-times-circle-o mbr-iconfont mbr-iconfont-btn" style="color: rgb(228, 63, 63)"></span>
                        {{ 'menu.logout' | translate | uppercase }}
                    </a>
                </li>
                <li class="nav-item">
                    <select id="languageSelector" class="select2" [(ngModel)]="selectedLanguage">
                        <option *ngFor="let item of languages" [value]="item.shortCode" [attr.data-icon]="item.flagImageUrl" [attr.data-name]="item.name | uppercase"></option>
                    </select>
                </li>
            </ul>
        </div>
    </div>
</nav>
